export const SALAMANDER_BASE = "https://tonejs.github.io/audio/salamander/";

// Sparse note set sampled every minor third — Tone.Sampler pitch-shifts to fill gaps.
// Filenames use 's' instead of '#' (e.g. Ds1.mp3 = D#1).
export const PIANO_URLS: Record<string, string> = {
  A0:   "A0.mp3",
  C1:   "C1.mp3",
  "D#1": "Ds1.mp3",
  "F#1": "Fs1.mp3",
  A1:   "A1.mp3",
  C2:   "C2.mp3",
  "D#2": "Ds2.mp3",
  "F#2": "Fs2.mp3",
  A2:   "A2.mp3",
  C3:   "C3.mp3",
  "D#3": "Ds3.mp3",
  "F#3": "Fs3.mp3",
  A3:   "A3.mp3",
  C4:   "C4.mp3",
  "D#4": "Ds4.mp3",
  "F#4": "Fs4.mp3",
  A4:   "A4.mp3",
  C5:   "C5.mp3",
  "D#5": "Ds5.mp3",
  "F#5": "Fs5.mp3",
  A5:   "A5.mp3",
  C6:   "C6.mp3",
  "D#6": "Ds6.mp3",
  "F#6": "Fs6.mp3",
  A7:   "A7.mp3",
};

export const GUITAR_BASE = "https://nbrosowsky.github.io/tonejs-instruments/samples/guitar-electric/";

export const GUITAR_URLS: Record<string, string> = {
  "A2":  "A2.mp3",  "A3":  "A3.mp3",  "A4":  "A4.mp3",  "A5":  "A5.mp3",
  "C3":  "C3.mp3",  "C4":  "C4.mp3",  "C5":  "C5.mp3",  "C6":  "C6.mp3",
  "C#2": "Cs2.mp3",
  "D#3": "Ds3.mp3", "D#4": "Ds4.mp3", "D#5": "Ds5.mp3",
  "E2":  "E2.mp3",
  "F#2": "Fs2.mp3", "F#3": "Fs3.mp3", "F#4": "Fs4.mp3", "F#5": "Fs5.mp3",
};

export const DRUM_BASE = "https://tonejs.github.io/audio/drum-samples/breakbeat8/";

export const DRUM_URLS: Record<string, string> = {
  kick:  "kick.mp3",
  snare: "snare.mp3",
  hihat: "hihat.mp3",
};

// Vinyl crackle — CC0 (public domain), DefySolipsis on Freesound (sound #531438).
export const VINYL_URL = "https://cdn.freesound.org/previews/531/531438_9121616-lq.mp3";
